import { render, staticRenderFns } from "./DataAvailability.vue?vue&type=template&id=164cc92c&scoped=true&"
import script from "./DataAvailability.vue?vue&type=script&lang=js&"
export * from "./DataAvailability.vue?vue&type=script&lang=js&"
import style0 from "./DataAvailability.vue?vue&type=style&index=0&id=164cc92c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164cc92c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
